$primary-green: #81ba43;
$secondary-green: #7fb02f;

.wrap {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 0.5rem;
	padding: 0.3rem 0;
	width: 100%;
	box-sizing: border-box;
	overflow: hidden;
}

.scroller {
	display: flex;
	flex-wrap: wrap;
	gap: 0.5rem;
	flex: 1;
	min-width: 0;
	overflow: visible;
}

.badge {
	display: inline-flex;
	align-items: center;
	gap: 0.35rem;
	background: #fafafa;
	color: #111827;
	border: 1px solid #e5e7eb;
	border-radius: 9999px;
	padding: 0.35rem 0.6rem;
	font-size: 0.85rem;
	white-space: nowrap;
	transition:
		border-color 0.15s ease,
		background 0.15s ease;

	&:hover {
		background: #f5f5f5;
	}
}

.badgeKey {
	font-weight: 600;
	color: #374151;
}

.badgeVal {
	color: #111827;
}

.badgeClose {
	background: transparent;
	border: 0;
	display: grid;
	place-items: center;
	color: #6b7280;
	cursor: pointer;

	&:hover {
		color: #111827;
	}
}

@media (max-width: 640px) {
	.wrap {
		flex-direction: row;
		align-items: center;
		gap: 0.4rem;
		padding: 0.25rem 0;
	}
	.scroller {
		display: none;
	}
	.compactSummary {
		display: inline-flex;
	}
}

.compactSummary {
	display: none;
	align-items: center;
	gap: 0.35rem;
	background: #ecfdf5;
	border: 1px solid #a7f3d0;
	color: #065f46;
	border-radius: 999px;
	padding: 0.3rem 0.7rem;
	font-size: 0.78rem;
	font-weight: 600;
	white-space: nowrap;
	flex: 1;
	min-width: 0;
}

.compactSummaryLabel {
	overflow: hidden;
	text-overflow: ellipsis;
}

.compactClear {
	background: transparent;
	border: 0;
	cursor: pointer;
	color: inherit;
	display: grid;
	place-items: center;
	padding: 0;
}
